// Import the same component files

import StartNutritionPlan from "pages/healthAnalyse-Plan2/Start/Start";
import {
  ANLEGEN,
  BENEFITS,
  CHALLENGE,
  CLOSE,
  EMPFEHLUNG,
  ERNAEHRUNGSFORM,
  HEALTHANALYSE_APP,
  KALORIEN,
  OPTION,
  PASSWORT,
  REZEPT,
  START_NUTRITION_PLAN,
  TEILNEHMER,
} from "./routes";
import Ernahrungsform from "pages/healthAnalyse-Plan2/Ernahrungsform/Ernahrungsform";
import Rezept from "pages/healthAnalyse-Plan2/Rezept/Rezept";
import Kalorien from "pages/healthAnalyse-Plan2/Kalorien/Kalorien";
import Teilnehmer from "pages/healthAnalyse-Plan2/Teilnehmer/Teilnehmer";
import Anlegen from "pages/healthAnalyse-Plan2/Anlegen/Anlegen";
import HealthAnalyseApp from "pages/healthAnalyse-Plan2/HealthAnalyse-App/App";
import Benefits from "pages/healthAnalyse-Plan2/Benefits/Benefits";
import Option from "pages/healthAnalyse-Plan2/Option/Option";
import Close from "pages/healthAnalyse-Plan2/Close/Close";
import Passwort from "pages/healthAnalyse-Plan2/Passwort/Passwort";
import Empfehlung from "pages/healthAnalyse-Plan2/Empfehlung/Empfehlung";
import Challenge from "pages/healthAnalyse-Plan2/Challenge/Challenge";

// Create a new dynamic route for meals, but under health_analyse

// Define all routes with health_analyse prefix
const HEALTH_ANALYSE_PLAN_2_ROUTES = [
  {
    path: START_NUTRITION_PLAN,
    component: StartNutritionPlan,
    progressStep: 1,
  },
  {
    path: ERNAEHRUNGSFORM,
    component: Ernahrungsform,
    progressStep: 1,
  },
  {
    path: REZEPT,
    component: Rezept,
    progressStep: 1,
  },
  {
    path: KALORIEN,
    component: Kalorien,
    progressStep: 1,
  },
  {
    path: TEILNEHMER,
    component: Teilnehmer,
    progressStep: 1,
  },
  {
    path: ANLEGEN,
    component: Anlegen,
    progressStep: 1,
  },
  {
    path: HEALTHANALYSE_APP,
    component: HealthAnalyseApp,
    progressStep: 1,
  },
  {
    path: BENEFITS,
    component: Benefits,
    progressStep: 1,
  },
  {
    path: OPTION,
    component: Option,
    progressStep: 1,
  },
  {
    path: CHALLENGE,
    component: Challenge,
    progressStep: 1,
  },
  {
    path: CLOSE,
    component: Close,
    progressStep: 2,
  },
  {
    path: PASSWORT,
    component: Passwort,
    progressStep: 2,
  },
  { path: EMPFEHLUNG, component: Empfehlung, progressStep: 2 },
];

//

export default HEALTH_ANALYSE_PLAN_2_ROUTES;
